/* unplugin-vue-components disabled */import script from "./AgeVerifiction.vue?vue&type=script&setup=true&lang=js"
export * from "./AgeVerifiction.vue?vue&type=script&setup=true&lang=js"

import "./AgeVerifiction.vue?vue&type=style&index=0&id=33cbe586&lang=less"

const __exports__ = script;

export default __exports__